/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { noop } from "lodash";
import { forwardRef, useEffect } from "react";
import { useSearchInput } from "cms/search/hooks/use-search-input";
import { ReactComponent as CloseIcon } from "cms/assets/icons/x.svg";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

/**
 * @param {object} props
 * @param {boolean=} props.autoSearch
 * @param {boolean=} props.navigateOnSubmit
 * @param {SearchEvent=} props.onFocus
 * @param {SearchEvent=} props.onChange
 * @param {Partial<SearchInputClassNames>} props.classNames
 * @param {import('react').ReactNode} props.children
 * @param {import('react').Ref<HTMLInputElement>} ref
 */
export function _SearchInput (props, ref) {
    const {
        autoSearch,
        navigateOnSubmit,
        children,
        onFocus = noop,
        onChange: onQueryChange = noop,
    } = props;

    const {
        clear,
        onChange,
        onSubmit,
        query,
        search,
    } = useSearchInput(autoSearch, navigateOnSubmit);


    useEffect(
        () => {
            onQueryChange(query);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [query]
    );

    return (
        <form
            onSubmit={onSubmit}
            className={"quick-search-root"}
        >
            <div className={"quick-search-inputContainer"}>
                <input
                    ref={ref}
                    className={"quick-search-input"}
                    value={search}
                    type="text"
                    onChange={onChange}
                    placeholder="What are you looking for?"
                    aria-label="Search"
                    onFocus={onFocus}
                />

                {search && <button
                    type="button"
                    className={"quick-search-reset"}
                    onClick={clear}
                    aria-label="Clear the search query"
                >
                    <CloseIcon />
                </button>}
            </div>

            <button
                type="submit"
                className={"quick-search-submit"}
                aria-label="Submit the search query"
            >
                {children}
            </button>
        </form>
    );
}

export const QuickSearchInput = forwardRef(_SearchInput);
QuickSearchInput.displayName = "QuickSearchInput";

/**
 * @typedef {() => void} SearchEvent
 * @typedef {string | string[]} ClassName
 */

/**
 * @typedef {object} SearchInputClassNames
 * @property {ClassName} root
 * @property {ClassName} input
 * @property {ClassName} inputContainer
 * @property {ClassName} submit
 * @property {ClassName} reset
 */
